const Video = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="0.75"
                y="0.75"
                width="16.5"
                height="16.5"
                rx="2.25"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.2944 8.2729L7.19998 5.38243C6.573 5.02336 5.75 5.43631 5.75 6.11849V11.8815C5.75 12.5637 6.55334 12.9766 7.19998 12.6176L12.2944 9.72709C12.9019 9.4039 12.9019 8.61403 12.2944 8.2729Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Video
